import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.companyinfo');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import $ from "jquery";
import moment from "moment";

@Component({
    selector: 'wiz-page-companyinfo',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.companyinfo/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageCompanyinfoComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @ViewChild('editor')
    public editorElement: ElementRef;

    @ViewChild('boardEditorEl')
    public boardEditorEl: ElementRef;

    @ViewChild('chartCanvas')
    public chartCanvas: ElementRef;

    public company_id: any = null;
    public menu: string = 'news';
    public routerSub: any = null;

    public data: any = {
        bussinessNumber: '',
        companyName: ''
    };

    // News
    public items: any = [];
    public loaded: boolean = false;
    public item: any = {};
    public editor: any;
    public post_id: any = null;
    public comments: any;
    public vote: any;
    public nickname: any;
    public comment_text: any;
    public search: any = { page: 1, text: "" };
    public pagination: any = { end: -1, start: -1 };

    // Shareholder
    public snapshots: any = [];
    public selectedSnapshot: any = null;
    public shareholders: any = [];
    public totalShares: number = 0;
    public snapshotFileUrl: string = '';
    public fundOptions: any[] = [];
    public xlsxImporting: boolean = false;

    // Financial
    public financials: any = [];
    public financialYear: number = new Date().getFullYear();
    public annualData: any = null;
    public financialAllQuarters: any = [];
    public financialAllAnnuals: any = [];
    public financialViewMode: string = 'year';
    public financialChart: any = null;
    public financialColumns: any = [];

    // Patent
    public patents: any = [];
    public patentFilter: string = '';
    public patentTypeFilter: string = '';

    // Board (business, tech, overseas)
    public boardPosts: any = [];
    public boardTotal: number = 0;
    public boardPage: number = 1;
    public boardPagination: any = { start: 1, end: -1 };
    public boardPost: any = null;
    public boardEditor: any = null;

    // Support
    public supports: any = [];

    // Workforce
    public workforces: any = [];

    // Editing state
    public editingItem: any = null;

    public menus: any = [
        { key: 'news', label: '기업뉴스', icon: 'M12 7.5h1.5m-1.5 3h1.5m-7 8.25h9a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 3.75 6.75v10.5A2.25 2.25 0 0 0 6 19.5Zm-1.5-15v7.5m0 0H12' },
        { key: 'shareholder', label: '주주명부', icon: 'M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z' },
        { key: 'financial', label: '재무제표', icon: 'M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z' },
        { key: 'patent', label: '특허현황', icon: 'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z' },
        { key: 'business', label: '사업현황', icon: 'M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0' },
        { key: 'tech', label: '기술개발현황', icon: 'M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5' },
        { key: 'support', label: '지원사업현황', icon: 'M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z' },
        { key: 'workforce', label: '인력현황', icon: 'M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z' },
        { key: 'overseas', label: '해외진출현황', icon: 'M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418' },
        { key: 'mentors', label: '멘토 가능 리스트', icon: 'M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z' }
    ];

    public async ngOnInit() {
        await this.service.init();

        const { code, data } = await wiz.call("getSession");
        if (data) {
            this.company_id = data['id'];
        }

        this.menu = WizRoute.segment.menu || 'news';

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newMenu = WizRoute.segment.menu || 'news';
                if (newMenu !== this.menu) {
                    this.menu = newMenu;
                    await this.loadMenuData();
                    await this.service.render();
                }
            }
        });

        if (this.company_id) {
            await this.loadMenuData();
        }

        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.financialChart) { this.financialChart.destroy(); this.financialChart = null; }
        if (this.boardEditor) { this.boardEditor.destroy().catch(() => {}); this.boardEditor = null; }
    }

    public async loadMenuData() {
        // Cleanup board editor
        if (this.boardEditor) {
            try { this.boardEditor.destroy(); } catch (e) {}
            this.boardEditor = null;
        }
        this.boardPost = null;
        this.editingItem = null;

        switch (this.menu) {
            case 'news': await this.load(); break;
            case 'shareholder': await this.loadShareholders(); break;
            case 'financial':
                if (this.financialViewMode === 'all' || this.financialViewMode === 'chart') {
                    await this.loadFinancialsAll();
                } else {
                    await this.loadFinancials();
                }
                break;
            case 'patent': await this.loadPatents(); break;
            case 'business':
            case 'tech':
            case 'overseas':
                await this.loadBoardPosts();
                break;
            case 'support': await this.loadSupports(); break;
            case 'workforce': await this.loadWorkforces(); break;
            case 'mentors': await this.loadMentors(); break;
        }
    }

    public async navigate(menu: string) {
        this.service.href(`/companyinfo/${menu}`);
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    // ─── 기업 로그인 ───
    public async login() {
        let comLoginData = JSON.parse(JSON.stringify(this.data));
        if (!comLoginData.bussinessNumber) {
            this.alert('사업자등록번호를 입력해주십시오.');
            return;
        }
        if (!comLoginData.companyName) {
            this.alert('업체명을 정확히 입력해주십시오.');
            return;
        }
        let { code, data } = await wiz.call("login", comLoginData);
        if (code != 200) {
            this.alert(data);
            return;
        }
        this.company_id = data['id'];
        await this.loadMenuData();
        await this.service.render();
    }

    public async delsession() {
        await wiz.call("delSession");
        this.company_id = null;
        await this.service.render();
    }

    // ─── 뉴스 (기존 기능) ───
    public async load(page: number = 1) {
        if (!this.company_id) return;
        this.search.company_id = this.company_id;
        this.search.category = "news";
        this.search.page = page;
        this.loaded = false;
        this.items = [];
        let body = JSON.parse(JSON.stringify(this.search));
        body.category = "news";
        const { code, data } = await wiz.call("search", body);
        if (code != 200) return;
        let { rows, lastpage } = data;
        const startpage = Math.floor((page - 1) / 10) * 10 + 1;
        this.items = rows;
        this.pagination.start = startpage;
        this.pagination.end = lastpage;
        this.loaded = true;
        await this.service.render();
    }

    public async select(item) {
        if (item.id != 'new') {
            const { code, data } = await wiz.call("get", { id: item.id });
            if (code != 200) return await this.previous();
            item = data.item;
            this.vote = data.vote;
            this.comments = data.comments;
        }
        this.post_id = item.id;
        await this.service.render();
        let element: any = this.editorElement?.nativeElement;
        if (element && $(element).parent().find(".ck-content").length == 0) {
            const { ClassicEditor, createCKEditorConfig } = await import("src/libs/portal/season/ckeditor");
            let toolbar = 'heading | fontSize | bold italic strikethrough underline | blockQuote code | bulletedList numberedList | outdent indent | uploadImage insertTable link codeBlock horizontalLine | specialCharacters'.split(' ');
            this.editor = await ClassicEditor.create(element, createCKEditorConfig({ toolbar }));
        }
        if (item.id == 'new') {
            this.item = {
                category: 'news', fund_id: this.company_id,
                title: '', content: '', level: '일반',
                status: 'publish', mode: '일반', extra: {},
                created: moment().format("YYYY-MM-DD")
            };
        } else {
            this.item = item;
            if (!this.item.level) this.item.level = '일반';
            this.item.created = moment(item.created).format("YYYY-MM-DD");
        }
        if (this.editor) this.editor.data.set(this.item.content);
        if (!this.item.extra) this.item.extra = {};
        if (!this.item.extra.vote) this.item.extra.vote = [];
        await this.service.render();
    }

    public async previous() {
        this.post_id = null;
        this.vote = null;
        this.comments = null;
        this.item = {};
        await this.service.render();
    }

    public async update() {
        this.item.content = this.editor.data.get();
        this.item.company_id = this.company_id;
        let data: any = JSON.stringify(this.item);
        await wiz.call("update", { data: data });
        await this.alert('저장되었습니다', 'success');
        if (!this.item.id) {
            await this.previous();
            await this.load(this.search.page);
        }
    }

    public async delete() {
        let res: any = await this.alert("정말로 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        await wiz.call("delete", { id: this.item.id });
        await this.previous();
        await this.load(this.search.page);
    }

    public async upload() {
        let files = await this.service.file.select();
        if (files.length == 0) return;
        await this.service.loading.show();
        if (!this.item.extra.attachments) this.item.extra.attachments = [];
        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            fd.append('upload', files[i]);
            const { url } = await this.service.file.upload('/file/upload', fd, async (percent: number, total: number, position: number) => { });
            this.item.extra.attachments.push({ name: files[i].name, url: url });
        }
        await this.service.loading.hide();
        await this.service.render();
    }

    public async removeFile(file) {
        let res: any = await this.alert("정말로 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        this.item.extra.attachments.remove(file);
        await this.service.render();
    }

    // ─── 주주명부 (스냅샷 기반) ───
    public async loadShareholders() {
        const { code, data } = await wiz.call("load_snapshots");
        if (code == 200) {
            this.snapshots = data.snapshots || [];
            this.fundOptions = data.fund_options || [];
        }
        this.selectedSnapshot = null;
        this.shareholders = [];
        this.totalShares = 0;
        this.snapshotFileUrl = '';
        await this.service.render();
    }

    public async selectSnapshot(snapshot: any) {
        const { code, data } = await wiz.call("load_snapshot_shareholders", { snapshot_id: snapshot.id });
        if (code == 200) {
            this.selectedSnapshot = data.snapshot;
            this.shareholders = data.rows;
            this.totalShares = data.total_shares;
            this.snapshotFileUrl = data.snapshot.file_url || '';
            this.fundOptions = data.fund_options || this.fundOptions || [];
        }
        await this.service.render();
    }

    public async createSnapshot() {
        const { code, data } = await wiz.call("create_snapshot", { memo: '' });
        if (code != 200) return this.alert(data?.message || '생성 실패');
        await this.loadShareholders();
        if (this.snapshots.length > 0) {
            await this.selectSnapshot(this.snapshots[0]);
        }
    }

    public async deleteSnapshot() {
        if (!this.selectedSnapshot) return;
        let res = await this.alert("이 주주명부를 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        const { code, data } = await wiz.call("delete_snapshot", { snapshot_id: this.selectedSnapshot.id });
        if (code != 200) return this.alert(data?.message || '삭제 실패');
        await this.alert('삭제되었습니다', 'success');
        await this.loadShareholders();
    }

    public async uploadShareholderPdf() {
        let files = await this.service.file.select({ accept: '.pdf' });
        if (!files || files.length == 0) return;
        await this.service.loading.show();
        try {
            let fd = new FormData();
            fd.append('upload', files[0]);
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            this.snapshotFileUrl = url;
            const { code, data } = await wiz.call('parse_shareholder_pdf', { file_url: url });
            if (code == 200 && data.rows && data.rows.length > 0) {
                for (let row of data.rows) {
                    this.shareholders.push({
                        fund_id: row.fund_id || '',
                        fund_name: row.fund_name || '',
                        name: row.name || '',
                        personal_id_prefix: row.personal_id_prefix || '',
                        business_registed_number: row.business_registed_number || '',
                        gender_code: row.gender_code || '',
                        share_type: row.share_type || '보통주',
                        share_count: Number(row.share_count) || 0,
                        round: row.round || '',
                        acquired_date: row.acquired_date || '',
                        note: row.note || ''
                    });
                }
                this.recalcShareRatio();
                await this.alert(`PDF에서 ${data.rows.length}건의 주주 데이터를 추출했습니다.`, 'success');
            } else {
                await this.alert('PDF에서 주주 데이터를 자동으로 추출하지 못했습니다. 직접 입력해 주세요.', 'error');
            }
        } catch (e) {
            await this.alert('PDF 업로드 실패', 'error');
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public addShareholderRow() {
        this.shareholders.push({ fund_id: '', fund_name: '', name: '', personal_id_prefix: '', business_registed_number: '', gender_code: '', share_type: '보통주', share_count: 0, round: '', acquired_date: '', acquisition_price: 0, note: '' });
        this.service.render();
    }

    public removeShareholderRow(index: number) {
        this.shareholders.splice(index, 1);
        this.recalcShareRatio();
        this.service.render();
    }

    public recalcShareRatio() {
        const total = this.shareholders.reduce((sum: number, r: any) => sum + (Number(r.share_count) || 0), 0);
        this.totalShares = total;
        for (let r of this.shareholders) {
            r.share_ratio = total > 0 ? Math.round((Number(r.share_count) || 0) / total * 10000) / 100 : 0;
        }
    }

    public onlyDigits(value: any): string {
        return String(value || '').replace(/[^0-9]/g, '');
    }

    public formatBusinessNumber(value: any): string {
        const digits = this.onlyDigits(value);
        if (!digits) return '-';
        if (digits.length === 10) return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
        return String(value || digits);
    }

    public shareholderIdentityMissing(row: any): boolean {
        return !this.onlyDigits(row?.personal_id_prefix) && !this.onlyDigits(row?.business_registed_number);
    }

    public validateShareholders(): string {
        for (let i = 0; i < this.shareholders.length; i++) {
            if (this.shareholderIdentityMissing(this.shareholders[i])) {
                return `${i + 1}번째 행의 생년월일 앞자리 또는 사업자등록번호를 입력해 주세요.`;
            }
        }
        return '';
    }

    public async saveAllShareholders() {
        if (!this.selectedSnapshot) return;
        if (!this.selectedSnapshot.editable) {
            return this.alert('24시간이 지나 수정할 수 없습니다.');
        }
        const validationMessage = this.validateShareholders();
        if (validationMessage) return this.alert(validationMessage);
        const items = this.shareholders.map((r: any) => ({
            id: r.id || '',
            fund_id: r.fund_id || '',
            fund_name: r.fund_name || '',
            name: r.name,
            personal_id_prefix: r.personal_id_prefix || '',
            business_registed_number: r.business_registed_number || '',
            gender_code: r.gender_code || '',
            share_type: r.share_type,
            share_count: Number(r.share_count) || 0,
            round: r.round || '',
            acquired_date: r.acquired_date || '',
            acquisition_price: Number(r.acquisition_price) || 0,
            note: r.note || ''
        }));
        const { code, data } = await wiz.call("save_snapshot_shareholders", {
            snapshot_id: this.selectedSnapshot.id,
            data: JSON.stringify(items),
            file_url: this.snapshotFileUrl || ''
        });
        if (code != 200) return this.alert(data?.message || '저장 실패');
        await this.alert('저장되었습니다', 'success');
        await this.selectSnapshot(this.selectedSnapshot);
        const res = await wiz.call("load_snapshots");
        if (res.code == 200) {
            this.snapshots = res.data.snapshots || [];
            this.fundOptions = res.data.fund_options || this.fundOptions || [];
        }
        await this.service.render();
    }

    public onShareholderFundChange(item: any) {
        const fund = this.fundOptions.find((f: any) => String(f.fund_id) === String(item.fund_id));
        if (fund) {
            item.fund_name = fund.fund_name || fund.name || '';
            item.name = item.fund_name;
        } else {
            item.fund_id = '';
            item.fund_name = '';
        }
        this.service.render();
    }

    public async downloadShareholderTemplate() {
        try {
            const response = await fetch('/wiz/api/companyinfo/download_shareholder_template', {
                method: 'POST',
                body: new FormData(),
                credentials: 'same-origin'
            });
            if (!response.ok) throw new Error('download failed');
            const blob = await response.blob();
            if (blob.size === 0) throw new Error('empty file');
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
            a.download = `주주명부_양식_${today}.xlsx`;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            await this.alert('엑셀 양식 다운로드 실패');
        }
    }

    public async uploadShareholderExcel() {
        if (!this.selectedSnapshot) return;
        const files = await this.service.file.select({ accept: '.xlsx' });
        if (!files || files.length === 0) return;
        const ok = await this.alert(`"${files[0].name}" 데이터를 현재 주주명부에 추가합니다. 저장 버튼을 눌러야 반영됩니다.`, 'success', '취소', '불러오기');
        if (!ok) return;
        this.xlsxImporting = true;
        await this.service.render();
        try {
            const fd = new FormData();
            fd.append('file', files[0]);
            const response = await fetch('/wiz/api/companyinfo/import_shareholder_excel', {
                method: 'POST',
                body: fd,
                credentials: 'include'
            });
            const json = await response.json();
            if (!response.ok || !json?.data?.rows) {
                throw new Error(json?.data?.message || '엑셀 파싱 오류');
            }
            this.fundOptions = json.data.fund_options || this.fundOptions || [];
            for (const row of json.data.rows) {
                this.shareholders.push({
                    fund_id: row.fund_id || '',
                    fund_name: row.fund_name || '',
                    name: row.name || row.fund_name || '',
                    personal_id_prefix: row.personal_id_prefix || '',
                    business_registed_number: row.business_registed_number || '',
                    gender_code: row.gender_code || '',
                    share_type: row.share_type || '보통주',
                    share_count: Number(row.share_count) || 0,
                    round: row.round || '',
                    acquired_date: row.acquired_date || '',
                    acquisition_price: Number(row.acquisition_price) || 0,
                    note: row.note || ''
                });
            }
            this.recalcShareRatio();
            await this.alert(`${json.data.rows.length}건을 불러왔습니다. 저장 버튼을 눌러 반영하세요.`, 'success');
        } catch (e: any) {
            await this.alert(e?.message || '엑셀 업로드 실패');
        } finally {
            this.xlsxImporting = false;
            await this.service.render();
        }
    }

    public formatDate(d: any) {
        if (!d) return '';
        return moment(d).format('YYYY-MM-DD HH:mm');
    }

    // ─── 재무제표 ───
    public async loadFinancials() {
        const { code, data } = await wiz.call("load_financials", { year: this.financialYear });
        if (code == 200) {
            this.financials = data.rows;
            this.annualData = data.annual;
        }
        await this.service.render();
    }

    public async loadFinancialsAll() {
        const { code, data } = await wiz.call("load_financials_all");
        if (code == 200) {
            this.financialAllQuarters = data.quarters || [];
            this.financialAllAnnuals = data.annuals || [];
            this.buildFinancialColumns();
        }
        await this.service.render();
    }

    public buildFinancialColumns() {
        const cols: any[] = [];
        for (const q of this.financialAllQuarters) {
            cols.push({ label: `${q.year} ${q.quarter}Q`, year: q.year, quarter: q.quarter, type: 'quarter', data: q });
        }
        for (const a of this.financialAllAnnuals) {
            cols.push({ label: `${a.year} 연간`, year: a.year, type: 'annual', data: a });
        }
        cols.sort((a: any, b: any) => {
            if (a.year !== b.year) return a.year - b.year;
            if (a.type === 'annual') return 1;
            if (b.type === 'annual') return -1;
            return (a.quarter || 0) - (b.quarter || 0);
        });
        this.financialColumns = cols;
    }

    public financialRows: any[] = [
        { key: 'revenue', label: '매출액', group: '손익' },
        { key: 'cost_of_sales', label: '매출원가', group: '손익' },
        { key: 'gross_profit', label: '매출총이익', group: '손익' },
        { key: 'sga_expenses', label: '판관비', group: '손익' },
        { key: 'operating_income', label: '영업이익', group: '손익' },
        { key: 'net_income', label: '당기순이익', group: '손익' },
        { key: 'total_assets', label: '자산총계', group: '재무상태' },
        { key: 'current_assets', label: '유동자산', group: '재무상태' },
        { key: 'non_current_assets', label: '비유동자산', group: '재무상태' },
        { key: 'total_liabilities', label: '부채총계', group: '재무상태' },
        { key: 'current_liabilities', label: '유동부채', group: '재무상태' },
        { key: 'non_current_liabilities', label: '비유동부채', group: '재무상태' },
        { key: 'total_equity', label: '자본총계', group: '재무상태' }
    ];

    public async setFinancialViewMode(mode: string) {
        this.financialViewMode = mode;
        if (mode === 'all' || mode === 'chart') {
            await this.loadFinancialsAll();
        } else {
            await this.loadFinancials();
        }
        if (mode === 'chart') {
            await this.service.render();
            setTimeout(() => this.renderFinancialChart(), 200);
        }
        await this.service.render();
    }

    public async renderFinancialChart() {
        if (this.financialChart) {
            this.financialChart.destroy();
            this.financialChart = null;
        }
        const canvas = this.chartCanvas?.nativeElement;
        if (!canvas) return;

        const { Chart, registerables } = await import('chart.js');
        Chart.register(...registerables);

        const annuals = this.financialAllAnnuals;
        const labels = annuals.map((a: any) => `${a.year}년`);

        this.financialChart = new Chart(canvas, {
            type: 'bar',
            data: {
                labels,
                datasets: [
                    {
                        label: '매출액',
                        data: annuals.map((a: any) => a.revenue || 0),
                        backgroundColor: 'rgba(59, 130, 246, 0.7)',
                    },
                    {
                        label: '영업이익',
                        data: annuals.map((a: any) => a.operating_income || 0),
                        backgroundColor: 'rgba(16, 185, 129, 0.7)',
                    },
                    {
                        label: '당기순이익',
                        data: annuals.map((a: any) => a.net_income || 0),
                        backgroundColor: 'rgba(245, 158, 11, 0.7)',
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { position: 'top' },
                    title: { display: true, text: '연도별 손익 추이' }
                },
                scales: { y: { beginAtZero: true } }
            }
        });
    }

    public async saveFinancial(item: any) {
        const { code } = await wiz.call("save_financial", { data: JSON.stringify(item) });
        if (code != 200) return this.alert('저장 실패');
        this.editingItem = null;
        if (this.financialViewMode === 'all' || this.financialViewMode === 'chart') {
            await this.loadFinancialsAll();
            if (this.financialViewMode === 'chart') {
                await this.service.render();
                setTimeout(() => this.renderFinancialChart(), 200);
            }
        } else {
            await this.loadFinancials();
        }
    }

    public async deleteFinancial(id: string) {
        let res = await this.alert("삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        await wiz.call("delete_financial", { id });
        if (this.financialViewMode === 'all' || this.financialViewMode === 'chart') {
            await this.loadFinancialsAll();
        } else {
            await this.loadFinancials();
        }
    }

    public async addFinancial() {
        this.editingItem = {
            year: this.financialYear, quarter: 1,
            total_assets: 0, total_liabilities: 0, total_equity: 0,
            current_assets: 0, non_current_assets: 0,
            current_liabilities: 0, non_current_liabilities: 0,
            revenue: 0, cost_of_sales: 0, gross_profit: 0,
            sga_expenses: 0, operating_income: 0, net_income: 0,
            note: '', file_url: ''
        };
        await this.service.render();
    }

    public async uploadFinancialFile() {
        if (!this.editingItem) return;
        let files = await this.service.file.select({ accept: '.pdf,.xlsx,.xls' });
        if (!files || files.length == 0) return;
        await this.service.loading.show();
        let fd = new FormData();
        fd.append('upload', files[0]);
        const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
        this.editingItem.file_url = url;
        await this.service.loading.hide();
        await this.service.render();
    }

    // ─── 특허현황 ───
    public async loadPatents() {
        const { code, data } = await wiz.call("load_patents", {
            status: this.patentFilter,
            patent_type: this.patentTypeFilter
        });
        if (code == 200) this.patents = data.rows;
        await this.service.render();
    }

    public async savePatent(item: any) {
        const { code } = await wiz.call("save_patent", { data: JSON.stringify(item) });
        if (code != 200) return this.alert('저장 실패');
        this.editingItem = null;
        await this.loadPatents();
    }

    public async deletePatent(id: string) {
        let res = await this.alert("삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        await wiz.call("delete_patent", { id });
        await this.loadPatents();
    }

    public async addPatent() {
        this.editingItem = {
            title: '', application_number: '', application_date: '',
            registration_date: '', status: 'applied', note: '',
            patent_type: 'domestic', country: ''
        };
        await this.service.render();
    }

    // ─── 게시판형 (사업현황, 기술개발현황, 해외진출현황) ───
    public boardTitle(): string {
        const titles: any = { business: '사업현황', tech: '기술개발현황', overseas: '해외진출현황' };
        return titles[this.menu] || '';
    }

    public async loadBoardPosts(page: number = 1) {
        this.boardPage = page;
        this.boardPost = null;
        const { code, data } = await wiz.call("load_board_posts", { board_type: this.menu, page });
        if (code == 200) {
            this.boardPosts = data.rows || [];
            this.boardTotal = data.total || 0;
            const lastpage = data.lastpage || 0;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.boardPagination = { start: startpage, end: lastpage };
        }
        await this.service.render();
    }

    public async selectBoardPost(item: any) {
        if (item.id === 'new') {
            this.boardPost = { id: 'new', title: '', content: '' };
        } else {
            const { code, data } = await wiz.call("load_board_post", { board_type: this.menu, id: item.id });
            if (code == 200) {
                this.boardPost = data.item;
            } else {
                return await this.previousBoard();
            }
        }
        await this.service.render();

        let element: any = this.boardEditorEl?.nativeElement;
        if (element && $(element).parent().find(".ck-content").length === 0) {
            const { ClassicEditor, createCKEditorConfig } = await import("src/libs/portal/season/ckeditor");
            let toolbar = 'heading | fontSize | bold italic strikethrough underline | blockQuote code | bulletedList numberedList | outdent indent | uploadImage insertTable link codeBlock horizontalLine | specialCharacters'.split(' ');
            this.boardEditor = await ClassicEditor.create(element, createCKEditorConfig({ toolbar }));
        }
        if (this.boardEditor) this.boardEditor.data.set(this.boardPost.content || '');
        await this.service.render();
    }

    public async previousBoard() {
        this.boardPost = null;
        if (this.boardEditor) {
            try { this.boardEditor.destroy(); } catch (e) {}
            this.boardEditor = null;
        }
        await this.service.render();
    }

    public async saveBoardPost() {
        if (!this.boardPost) return;
        this.boardPost.content = this.boardEditor ? this.boardEditor.data.get() : '';
        const postData = JSON.parse(JSON.stringify(this.boardPost));
        if (postData.id === 'new') delete postData.id;
        const { code } = await wiz.call("save_board_post", { board_type: this.menu, data: JSON.stringify(postData) });
        if (code != 200) return this.alert('저장 실패');
        await this.alert('저장되었습니다', 'success');
        await this.previousBoard();
        await this.loadBoardPosts(this.boardPage);
    }

    public async deleteBoardPost() {
        if (!this.boardPost || this.boardPost.id === 'new') return;
        let res = await this.alert("정말로 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        await wiz.call("delete_board_post", { board_type: this.menu, id: this.boardPost.id });
        await this.previousBoard();
        await this.loadBoardPosts(this.boardPage);
    }

    // ─── 지원사업현황 ───
    public async loadSupports() {
        const { code, data } = await wiz.call("load_supports");
        if (code == 200) this.supports = data.rows;
        await this.service.render();
    }

    public async saveSupport(item: any) {
        const { code } = await wiz.call("save_support", { data: JSON.stringify(item) });
        if (code != 200) return this.alert('저장 실패');
        this.editingItem = null;
        await this.loadSupports();
    }

    public async deleteSupport(id: string) {
        let res = await this.alert("삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        await wiz.call("delete_support", { id });
        await this.loadSupports();
    }

    public async addSupport() {
        this.editingItem = { title: '', content: '', agency: '', amount: 0, start_date: '', end_date: '', note: '' };
        await this.service.render();
    }

    public supportStatusInfo(item: any): any {
        if (!item.end_date) return { label: '진행중', bg: 'bg-yellow-100', text: 'text-yellow-700' };
        const end = new Date(item.end_date);
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        if (end < now) return { label: '완료', bg: 'bg-green-100', text: 'text-green-700' };
        return { label: '진행중', bg: 'bg-yellow-100', text: 'text-yellow-700' };
    }

    // ─── 인력현황 ───
    public async loadWorkforces() {
        const { code, data } = await wiz.call("load_workforces");
        if (code == 200) this.workforces = data.rows;
        await this.service.render();
    }

    public async saveWorkforce(item: any) {
        const { code } = await wiz.call("save_workforce", { data: JSON.stringify(item) });
        if (code != 200) return this.alert('저장 실패');
        this.editingItem = null;
        await this.loadWorkforces();
    }

    public async deleteWorkforce(id: string) {
        let res = await this.alert("삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        await wiz.call("delete_workforce", { id });
        await this.loadWorkforces();
    }

    public async addWorkforce() {
        this.editingItem = { executive_count: 0, employee_count: 0, base_date: '', note: '' };
        await this.service.render();
    }

    public cancelEdit() {
        this.editingItem = null;
        this.service.render();
    }

    public formatNumber(n: any) {
        if (n == null || n == undefined) return '0';
        return Number(n).toLocaleString();
    }

    public genderLabel(value: any) {
        const code = String(value || '');
        const labels: any = { '1': '1 남', '2': '2 여', '3': '3 남', '4': '4 여' };
        return labels[code] || code || '-';
    }

    public statusLabel(status: string, type: string = '') {
        const labels: any = {
            patent: { applied: '출원중', registered: '등록', rejected: '거절' },
            support: { applied: '신청', active: '수행중', completed: '완료' }
        };
        return labels[type]?.[status] || status;
    }

    public patentTypeLabel(t: string) {
        return t === 'overseas' ? '해외' : '국내';
    }

    // ─── 멘토 가능 리스트 ───
    public mentors: any[] = [];
    public mentorSearch: string = '';
    public mentorsLoaded: boolean = false;

    public async loadMentors() {
        this.mentorsLoaded = false;
        const { code, data } = await wiz.call("load_mentors");
        if (code == 200) this.mentors = data.rows || [];
        this.mentorsLoaded = true;
        await this.service.render();
    }

    public filteredMentors() {
        const q = (this.mentorSearch || '').trim().toLowerCase();
        if (!q) return this.mentors;
        return this.mentors.filter((m: any) => {
            const hay = [
                m.name, m.company, m.title, m.about, m.expert_career, m.expert_keywords,
                ...(m.field || []), ...(m.sub_field || [])
            ].filter(Boolean).join(' ').toLowerCase();
            return hay.indexOf(q) !== -1;
        });
    }
}

export default PageCompanyinfoComponent;